var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c("BjPage", {
        ref: "BjPage",
        attrs: {
          "query-params": _vm.queryParams,
          "col-span": _vm.colSpan,
          "label-width": "80px",
          "get-action": _vm.queryApi,
          serial: _vm.serial,
        },
        on: {
          showSetting: _vm.SortableTable.show,
          "header-dragend": _vm.SortableTable.handleHeaderDragend,
          "header-contextmenu": _vm.SortableTable.handleHeaderContextmenu,
        },
        scopedSlots: _vm._u([
          {
            key: "baseForm",
            fn: function () {
              return [
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("AccountManagement.common.status"),
                          prop: "prohibits",
                        },
                      },
                      [
                        _c("BjSelectLov", {
                          attrs: {
                            "option-list": _vm.STATUS_ENABLED_NUM,
                            clearable: false,
                            placeholder: _vm.$t(
                              "AccountManagement.common.status"
                            ),
                          },
                          on: { change: _vm.changeProhibit },
                          model: {
                            value: _vm.queryParams.prohibits,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "prohibits", $$v)
                            },
                            expression: "queryParams.prohibits",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("WorkorderType.table.InquiryType"),
                          prop: "consultName",
                        },
                      },
                      [
                        _c("BjSelectLov", {
                          attrs: {
                            "option-list": _vm.consultNameList,
                            clearable: false,
                            placeholder: _vm.$t(
                              "WorkorderType.table.InquiryType"
                            ),
                          },
                          model: {
                            value: _vm.queryParams.consultName,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "consultName", $$v)
                            },
                            expression: "queryParams.consultName",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "tableOperation",
            fn: function () {
              return [
                _c(
                  "el-col",
                  [
                    _c(
                      "el-button",
                      {
                        staticClass: "main-btn",
                        attrs: { type: "primary" },
                        on: { click: _vm.addType },
                      },
                      [_vm._v(_vm._s(_vm.$t("WorkorderType.Addwork")))]
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "tableColumn",
            fn: function () {
              return [
                _vm._l(_vm.dropCols, function (col, index) {
                  return [
                    col.prop !== "bjTableAction"
                      ? _c("el-table-column", {
                          key:
                            "col_" +
                            index +
                            "_" +
                            col.prop +
                            "_" +
                            (col.width || "auto"),
                          attrs: {
                            prop: col.prop,
                            label: col.label,
                            width: col.width || "auto",
                            fixed: col.fixed || false,
                            align: "center",
                            "class-name": "item",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    false
                                      ? void 0
                                      : col.prop === "prohibits"
                                      ? _c(
                                          "el-tag",
                                          {
                                            attrs: {
                                              type: scope.row.prohibits
                                                ? "success"
                                                : "info",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  _vm.STATUS_ENABLED_NUM.bjGet(
                                                    scope.row.prohibits
                                                  )
                                                )
                                              )
                                            ),
                                          ]
                                        )
                                      : col.prop === "requiresAttach"
                                      ? _c(
                                          "el-tag",
                                          {
                                            attrs: {
                                              type: scope.row.requiresAttach
                                                ? "success"
                                                : "info",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  _vm.STATUS_YES_NUM.bjGet(
                                                    scope.row.requiresAttach
                                                  )
                                                )
                                              )
                                            ),
                                          ]
                                        )
                                      : _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("timeFilters")(
                                                scope.row[col.prop],
                                                scope.row[col.prop]
                                              )
                                            )
                                          ),
                                        ]),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : _vm._e(),
                    col.prop === "bjTableAction"
                      ? _c("el-table-column", {
                          key:
                            "col_" +
                            index +
                            "_" +
                            col.prop +
                            "_" +
                            (col.width || "auto"),
                          attrs: {
                            prop: col.prop,
                            label: col.label,
                            width: col.width || "auto",
                            fixed: col.fixed || "right",
                            align: "center",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (props) {
                                  return [
                                    _c(
                                      "el-dropdown",
                                      {
                                        directives: [
                                          {
                                            name: "hasDropdownChildren",
                                            rawName: "v-hasDropdownChildren",
                                          },
                                        ],
                                        attrs: { size: "mini" },
                                        on: {
                                          command: function ($event) {
                                            return _vm.command(
                                              $event,
                                              props.row
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "el-dropdown-link" },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$t("table.operationText")
                                                )
                                            ),
                                            _c("i", {
                                              staticClass:
                                                "el-icon-arrow-down el-icon--right",
                                            }),
                                          ]
                                        ),
                                        _c(
                                          "el-dropdown-menu",
                                          {
                                            attrs: { slot: "dropdown" },
                                            slot: "dropdown",
                                          },
                                          [
                                            !props.row.prohibits
                                              ? _c(
                                                  "el-dropdown-item",
                                                  {
                                                    attrs: {
                                                      command:
                                                        _vm.$t("enableText"),
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t("enableText")
                                                      )
                                                    ),
                                                  ]
                                                )
                                              : _c(
                                                  "el-dropdown-item",
                                                  {
                                                    attrs: {
                                                      command:
                                                        _vm.$t("disableText"),
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t("disableText")
                                                      )
                                                    ),
                                                  ]
                                                ),
                                            !props.row.prohibits
                                              ? _c(
                                                  "el-dropdown-item",
                                                  {
                                                    attrs: {
                                                      command:
                                                        _vm.$t("editText"),
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(_vm.$t("editText"))
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                            _c(
                                              "el-dropdown-item",
                                              {
                                                attrs: {
                                                  command: _vm.$t(
                                                    "WorkorderType.common.Log"
                                                  ),
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "RoleManagement.common.Log"
                                                    )
                                                  )
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : _vm._e(),
                  ]
                }),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t("WorkorderType.Addwork"),
            visible: _vm.addDialogVisible,
            width: "800px",
            "before-close": _vm.handleClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.addDialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "form",
              attrs: {
                model: _vm.form,
                "status-icon": "",
                rules: _vm.rules,
                "label-width": "250px",
                "label-position": "top",
              },
            },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("WorkorderType.table.InquiryType"),
                    prop: "consultName",
                  },
                },
                [
                  _c("BjSelectLov", {
                    attrs: {
                      "option-list": _vm.consultNameList,
                      clearable: false,
                      placeholder: _vm.$t("WorkorderType.table.InquiryType"),
                    },
                    model: {
                      value: _vm.form.consultName,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "consultName", $$v)
                      },
                      expression: "form.consultName",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("WorkorderType.table.ServiceType"),
                    prop: "name",
                  },
                },
                [
                  _c("BjInput", {
                    attrs: { placeholder: _vm.$t("inputText") },
                    model: {
                      value: _vm.form.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "name", $$v)
                      },
                      expression: "form.name",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("WorkorderType.table.TypeErrordescription"),
                    prop: "remark",
                  },
                },
                [
                  _c("BjInput", {
                    attrs: {
                      type: "textarea",
                      maxlength: _vm.MAX_LENGTH.NORMAL_REMARK,
                      "show-word-limit": "",
                      placeholder: _vm.$t("inputText"),
                    },
                    model: {
                      value: _vm.form.remark,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "remark", $$v)
                      },
                      expression: "form.remark",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("WorkorderType.table.Feeitems"),
                    prop: "pay",
                  },
                },
                [
                  _c(
                    "BjInput",
                    {
                      attrs: {
                        disabled: true,
                        placeholder: _vm.$t("inputText"),
                      },
                      model: {
                        value: _vm.form.pay,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "pay", $$v)
                        },
                        expression: "form.pay",
                      },
                    },
                    [
                      _c(
                        "template",
                        { slot: "append" },
                        [
                          _c("el-button", { on: { click: _vm.openSKU } }, [
                            _vm._v(_vm._s(_vm.$t("chooseText"))),
                          ]),
                        ],
                        1
                      ),
                    ],
                    2
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("WorkorderType.table.attachments") } },
                [
                  _c("BjRadioLov", {
                    attrs: { "option-list": _vm.STATUS_YES_NUMBER },
                    model: {
                      value: _vm.form.requiresAttach,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "requiresAttach", $$v)
                      },
                      expression: "form.requiresAttach",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.handleClose } }, [
                _vm._v(_vm._s(_vm.$t("cancelText"))),
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.submitForm("form")
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("okText")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("log-list", { ref: "logListRef" }),
      _c("BjDialogList", {
        ref: "dialogListChangeItem",
        attrs: {
          width: "80%",
          config: _vm.$BjDialogListConfig.chargeItemDefault(
            "route.BusinessBillingCategories",
            {
              defaultQuery: {
                tags: "Ticket1,Ticket2,Free",
                tenantId: _vm.$store.getters.tenantId,
              },
            }
          ),
          resetBtnHide: true,
          searchBtnHide: true,
          multiple: "",
        },
        on: { confirm: _vm.onAddChargeItemConfirm },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }